import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { AlertCircle, CheckCircle } from 'lucide-react';
type VendorInterestFormData = {
  name: string;
  companyName: string;
  email: string;
  phone: string;
  serviceTypes: string[];
  message: string;
};
export function VendorInterestForm() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const {
    register,
    handleSubmit,
    formState: {
      errors,
      isSubmitting
    },
    reset
  } = useForm<VendorInterestFormData>();
  const onSubmit = (data: VendorInterestFormData) => {
    // In a real application, this would send the data to an API endpoint
    console.log('Vendor interest data:', data);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitted(true);
      reset();
    }, 1000);
  };
  if (isSubmitted) {
    return <div className="bg-white p-8 rounded-lg shadow-sm border border-gray-200 text-center" data-id="element-531">
        <div className="mx-auto h-16 w-16 flex items-center justify-center rounded-full bg-green-100 mb-4" data-id="element-532">
          <CheckCircle className="h-10 w-10 text-green-600" data-id="element-533" />
        </div>
        <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-534">
          Thank You for Your Interest!
        </h3>
        <p className="text-gray-600 mb-4" data-id="element-535">
          We've received your information and our vendor relations team will
          contact you within 2-3 business days to discuss the next steps.
        </p>
        <p className="text-sm text-gray-500" data-id="element-536">
          If you have any questions, please contact us at{' '}
          <a href="mailto:vendors@smarthomebox.my" className="text-primary" data-id="element-537">
            vendors@smarthomebox.my
          </a>
        </p>
      </div>;
  }
  return <form onSubmit={handleSubmit(onSubmit)} className="space-y-6" data-id="element-538">
      <div data-id="element-539">
        <label htmlFor="name" className="block text-sm font-medium text-gray-700" data-id="element-540">
          Full Name
        </label>
        <div className="mt-1 relative" data-id="element-541">
          <input id="name" type="text" className={`block w-full px-4 py-3 rounded-md border ${errors.name ? 'border-red-300' : 'border-gray-300'} focus:outline-none focus:ring-primary focus:border-primary text-gray-900`} {...register('name', {
          required: 'Full name is required'
        })} placeholder="Your full name" data-id="element-542" />
          {errors.name && <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none" data-id="element-543">
              <AlertCircle className="h-5 w-5 text-red-500" data-id="element-544" />
            </div>}
        </div>
        {errors.name && <p className="mt-1 text-sm text-red-600" data-id="element-545">{errors.name.message}</p>}
      </div>
      <div data-id="element-546">
        <label htmlFor="companyName" className="block text-sm font-medium text-gray-700" data-id="element-547">
          Company Name
        </label>
        <div className="mt-1 relative" data-id="element-548">
          <input id="companyName" type="text" className={`block w-full px-4 py-3 rounded-md border ${errors.companyName ? 'border-red-300' : 'border-gray-300'} focus:outline-none focus:ring-primary focus:border-primary text-gray-900`} {...register('companyName', {
          required: 'Company name is required'
        })} placeholder="Your company name" data-id="element-549" />
          {errors.companyName && <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none" data-id="element-550">
              <AlertCircle className="h-5 w-5 text-red-500" data-id="element-551" />
            </div>}
        </div>
        {errors.companyName && <p className="mt-1 text-sm text-red-600" data-id="element-552">
            {errors.companyName.message}
          </p>}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-553">
        <div data-id="element-554">
          <label htmlFor="email" className="block text-sm font-medium text-gray-700" data-id="element-555">
            Email Address
          </label>
          <div className="mt-1 relative" data-id="element-556">
            <input id="email" type="email" className={`block w-full px-4 py-3 rounded-md border ${errors.email ? 'border-red-300' : 'border-gray-300'} focus:outline-none focus:ring-primary focus:border-primary text-gray-900`} {...register('email', {
            required: 'Email is required',
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: 'Invalid email address'
            }
          })} placeholder="Your email address" data-id="element-557" />
            {errors.email && <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none" data-id="element-558">
                <AlertCircle className="h-5 w-5 text-red-500" data-id="element-559" />
              </div>}
          </div>
          {errors.email && <p className="mt-1 text-sm text-red-600" data-id="element-560">{errors.email.message}</p>}
        </div>
        <div data-id="element-561">
          <label htmlFor="phone" className="block text-sm font-medium text-gray-700" data-id="element-562">
            Phone Number
          </label>
          <div className="mt-1 relative" data-id="element-563">
            <input id="phone" type="tel" className={`block w-full px-4 py-3 rounded-md border ${errors.phone ? 'border-red-300' : 'border-gray-300'} focus:outline-none focus:ring-primary focus:border-primary text-gray-900`} {...register('phone', {
            required: 'Phone number is required'
          })} placeholder="Your phone number" data-id="element-564" />
            {errors.phone && <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none" data-id="element-565">
                <AlertCircle className="h-5 w-5 text-red-500" data-id="element-566" />
              </div>}
          </div>
          {errors.phone && <p className="mt-1 text-sm text-red-600" data-id="element-567">{errors.phone.message}</p>}
        </div>
      </div>
      <div data-id="element-568">
        <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-569">
          Services Offered
        </label>
        <div className="space-y-2" data-id="element-570">
          <div className="flex items-start" data-id="element-571">
            <div className="flex items-center h-5" data-id="element-572">
              <input id="painting" type="checkbox" className="h-4 w-4 text-primary focus:ring-primary border-gray-300 rounded" {...register('serviceTypes')} value="painting" data-id="element-573" />
            </div>
            <div className="ml-3 text-sm" data-id="element-574">
              <label htmlFor="painting" className="font-medium text-gray-700" data-id="element-575">
                Painting
              </label>
            </div>
          </div>
          <div className="flex items-start" data-id="element-576">
            <div className="flex items-center h-5" data-id="element-577">
              <input id="waterproofing" type="checkbox" className="h-4 w-4 text-primary focus:ring-primary border-gray-300 rounded" {...register('serviceTypes')} value="waterproofing" data-id="element-578" />
            </div>
            <div className="ml-3 text-sm" data-id="element-579">
              <label htmlFor="waterproofing" className="font-medium text-gray-700" data-id="element-580">
                Waterproofing
              </label>
            </div>
          </div>
          <div className="flex items-start" data-id="element-581">
            <div className="flex items-center h-5" data-id="element-582">
              <input id="micro-repair" type="checkbox" className="h-4 w-4 text-primary focus:ring-primary border-gray-300 rounded" {...register('serviceTypes')} value="micro-repair" data-id="element-583" />
            </div>
            <div className="ml-3 text-sm" data-id="element-584">
              <label htmlFor="micro-repair" className="font-medium text-gray-700" data-id="element-585">
                Micro-Repair
              </label>
            </div>
          </div>
        </div>
        {errors.serviceTypes && <p className="mt-1 text-sm text-red-600" data-id="element-586">
            {errors.serviceTypes.message}
          </p>}
      </div>
      <div data-id="element-587">
        <label htmlFor="message" className="block text-sm font-medium text-gray-700" data-id="element-588">
          Additional Information
        </label>
        <div className="mt-1" data-id="element-589">
          <textarea id="message" rows={4} className="block w-full px-4 py-3 rounded-md border border-gray-300 focus:outline-none focus:ring-primary focus:border-primary" {...register('message')} placeholder="Tell us about your business experience, service areas, and why you want to join Smart Homebox" data-id="element-590"></textarea>
        </div>
      </div>
      <div data-id="element-591">
        <button type="submit" disabled={isSubmitting} className="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-white bg-primary hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:opacity-70" data-id="element-592">
          {isSubmitting ? 'Submitting...' : 'Submit Interest'}
        </button>
      </div>
    </form>;
}